// extracted by mini-css-extract-plugin
export default {"tag":"_5Y6dEn78Ve"};
    if(module.hot) {
      // 1648553781218
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  